export const lockScrolling = (lock = false) => lock
  ? document.body.classList.add('noscroll')
  : document.body.classList.remove('noscroll');
